/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import type { PriceData } from '../../../models/priceData/priceData';

import { isProductionEnvironment } from '../../../../../utility/environments';
import { setFullCart } from './cartHydrationActions';

export interface CartEditOrderSummaryState {
    editOrderSubtotalDifferencePriceData: PriceData;
    editOrderSubtotalPriceData: PriceData;
    editOrderTotalDifferencePriceData: PriceData;
    editOrderTotalPriceData: PriceData;
}

interface CartEditOrderState {
    isInEditOrderMode: boolean;
    editOrderNumber: string | null;
    editOrderTimeout: string | null;
    editOrderSummary: CartEditOrderSummaryState;
    paymentExpirationDate: Date | undefined;
}

export const getInitialState = (): CartEditOrderState => ({
    isInEditOrderMode: false,
    editOrderNumber: null,
    editOrderTimeout: null,
    editOrderSummary: {
        editOrderSubtotalDifferencePriceData: {
            inclTaxPrice: undefined,
            exclTaxPrice: undefined,
        },
        editOrderSubtotalPriceData: {
            inclTaxPrice: undefined,
            exclTaxPrice: undefined,
        },
        editOrderTotalDifferencePriceData: {
            inclTaxPrice: undefined,
            exclTaxPrice: undefined,
        },
        editOrderTotalPriceData: {
            inclTaxPrice: undefined,
            exclTaxPrice: undefined,
        },
    },
    paymentExpirationDate: undefined,
});

const cartEditOrderSlice = createSlice({
    name: 'editOrder',
    initialState: getInitialState(),
    reducers: {
        mock: (state) => {
            if (!isProductionEnvironment) {
                state.isInEditOrderMode = true;
                state.editOrderNumber = '123456789';
                state.editOrderTimeout = new Date(
                    new Date().setHours(new Date().getHours() + 1),
                ).toISOString();
            } else {
                // eslint-disable-next-line no-console
                console.error('Not available in production environment');
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(setFullCart, (_state, action) => action.payload.editOrder);
    },
});

export const { actions: cartEditOrderActions, reducer: cartEditOrderReducer } = cartEditOrderSlice;
